import * as React from "react";
export function memo(component, propsAreEqual) {
  return /*#__PURE__*/React.memo(component, propsAreEqual);
}
//# sourceMappingURL=memo.js.map